import React, { useState } from 'react';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW1315Query } from './hooks/usePW1315Query';
import QueryParamsPanel from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryParams } from '../../services/pw1315Api';
import './PW1315Form.css';

const PW1315Form: React.FC = () => {
  const { loading, data, queried, noData, runQuery, reset } = usePW1315Query();
  const [codeFrom, setCodeFrom] = useState('');
  const [codeTo, setCodeTo] = useState('');

  const handleQuery = () => {
    const params: QueryParams = {
      codeFrom: codeFrom.trim() || undefined,
      codeTo: codeTo.trim() || undefined,
    };
    runQuery(params);
  };

  const handleReset = () => { setCodeFrom(''); setCodeTo(''); reset(); };

  const handlePrint = () => {
    if (!data || data.length === 0) return;
    const win = window.open('', '_blank');
    if (!win) return;
    const now = new Date().toLocaleString('zh-TW');
    win.document.write(`<!DOCTYPE html><html><head><title>包裝方式清冊</title>
<style>body{font-family:'Microsoft JhengHei',sans-serif;margin:20px;font-size:12px;}
h2{text-align:center;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #333;padding:4px 8px;}
th{background:#f0f0f0;text-align:center;}@media print{body{margin:10mm;}}</style></head><body>
<h2>包裝方式清冊</h2><div style="text-align:center;font-size:11px;color:#555;margin-bottom:12px;">列印時間: ${now}</div>
<table><thead><tr><th>代號</th><th>名稱</th></tr></thead><tbody>
${data.map(r => `<tr><td>${r.code}</td><td>${r.name}</td></tr>`).join('')}
</tbody></table></body></html>`);
    win.document.close(); win.focus(); win.print();
  };

  return (
    <PermissionGuard module={Modules.PW1315} action="query">
      <div className="pw1315-container">
        <div className="pw1315-header">
          <h2>包裝方式清冊</h2>
          <div className="pw1315-print-btn">
            {queried && !noData && <Button icon={<PrinterOutlined />} onClick={handlePrint}>列印</Button>}
          </div>
        </div>
        <QueryParamsPanel codeFrom={codeFrom} codeTo={codeTo} loading={loading}
          onCodeFromChange={setCodeFrom} onCodeToChange={setCodeTo}
          onQuery={handleQuery} onReset={handleReset} />
        <ResultTable data={data} loading={loading} queried={queried} noData={noData} />
      </div>
    </PermissionGuard>
  );
};

export default PW1315Form;
